import { RootState } from '../store';

export const selectBraintreeClientToken = ({ braintreeReducer }: RootState) => braintreeReducer.clientToken;
